export function jsonToForm(form, json, options = {}) {
  const { prefijo } = options;

  Object.keys(json).forEach((key) => {
    const name = prefijo ? `${prefijo}[${key}]` : key;
    form.querySelectorAll(`[name="${name}"]`).forEach((input) => {
      if (input.type === 'checkbox' || input.type === 'radio') {
        input.checked = json[key] === true;
      } else {
        input.value = json[key];
      }
    });
  });
}

/**
 * Devuelve el nombre del input (mensaje[usuario_id]) según los parámetros
 * @param {*} campo Nombre de Campo (usuario_id)
 * @param {*} modelo Modelo a utilizar (mensaje), es opcional
 */
export function inputName(campo, modelo, opciones) {
  let name;
  if (modelo) {
    name = `${modelo}[${campo}]`;
  } else {
    name = campo;
  }
  if (opciones?.array) {
    name = `${name}[]`;
  }

  return name;
}
